module.exports = __webpack_public_path__ + "img/hr-heat-pipe-t-up-1.4167952f.png";